import { DeploymentDataSource } from '@nx/ops';
import type { DataSourceModalArgs } from '@nx/state';
import { useActiveProjectQuery, useExternalConnectionsFlag } from '@nx/state';
import { isNotNullish } from '@nx/stdlib';
import { DataSourceModal as DataSourceModalUI } from '@nx/ui';
import { useState } from 'react';

import { InstancesDataSource } from './instances-data-source';

export function DataSourceModal(props: DataSourceModalArgs) {
  const [filter, setFilter] = useState(props.instanceNameFilter ?? '');
  const [deploymentFilter, setDeploymentFilter] = useState('');
  const activeProjectRes = useActiveProjectQuery();
  const externalConnectionsEnabled = useExternalConnectionsFlag();
  const fleetManagementEnabled = activeProjectRes.data?.capabilities.fleet_management;

  const showSelfManaged = externalConnectionsEnabled && isNotNullish(fleetManagementEnabled) && fleetManagementEnabled;

  return (
    <DataSourceModalUI
      dataSources={[
        {
          name: showSelfManaged ? 'Aura' : (activeProjectRes.data?.name ?? 'Aura'),
          element: <InstancesDataSource filter={filter} onFilterChange={setFilter} />,
        },
        ...(showSelfManaged
          ? [
              {
                name: 'Self-managed',
                element: <DeploymentDataSource filter={deploymentFilter} onFilterChange={setDeploymentFilter} />,
              },
            ]
          : []),
      ]}
      {...props}
    />
  );
}
